const t = "{{currentTime}} من أصل {{duration}}", A = "نتيجة البحث {{current}} من {{total}}", o = "لم يتم العثور على نتائج", n = "تم العثور على {{count}} نتيجة", E = "تم العثور على {{count}} من النتائج", c = 'التشغيل من $t(HOURS, { "count": {{hours}} }) و $t(MINUTES, { "count": {{minutes}} }) و$t(SECONDS, { "count": {{seconds}} }).', T = 'التشغيل من $t(MINUTES, { "count": {{minutes}} }) و$t(SECONDS, { "count": {{seconds}} }).', _ = 'التشغيل من $t(SECONDS, { "count": {{seconds}} }).', s = "وقع خطأ أثناء حفظ التغييرات في النسخة النصية.", S = "سطر النسخة النصية {{time}}. المحتوى: {{text}}.", N = 'حاوية أسطر النسخة النصية. يوجد $t(TRANSCRIPT_LINES, { "count": {{count}} }) ضمن هذه الحاوية. للتنقل داخل هذه الحاوية، استخدم مفتاح سهم لأسفل.', R = "جارٍ حفظ التغييرات...", O = "تم حفظ التغييرات في النسخة النصية.", I = "يتوفر الآن تحديث زر التعليقات التوضيحية.", C = "الإجراء", P = "إضافة تعليق توضيحي في {{time}}", U = "إضافة سؤال في {{time}}", L = "تعليقات توضيحية", D = "تلقائي", e = "تلقائي ({{quality}})", M = "عودة", u = "تسميات توضيحية", G = "لغة التسمية التوضيحية", Y = "إدارة التسميات التوضيحية", r = "حذف {{language}}", H = "حجم الخط", V = "لغة التسمية التوضيحية: {{language}}", B = "{{language}} (تلقائي)", a = "مسح البحث", i = "إغلاق", K = "التعليقات", m = "متابعة", F = "تخفيض سرعة التشغيل", d = "تخفيض مستوى الصوت بقدر {{percent}}%", l = "سهم لأسفل", W = "إغلاق محرر النسخة النصية", $ = "تحديث التعليقات التوضيحية", g = "خطأ!", h = "جارٍ الحفظ...", Q = "تم الحفظ!", J = "تحرير النسخة النصية", p = "لا يمكن ترك النص فارغًا!", x = "ملء الشاشة", Z = "{{count}} ساعة", f = "{{count}} من الساعات", X = "زيادة سرعة التشغيل", q = "زيادة مستوى الصوت بقدر {{percent}}%", v = "عكس الألوان", w = "انتقل إلى النسبة المئوية المحددة (1-10%، 2-20%، وما شابه)", y = "انتقل إلى البداية", b = "الإجراءات الخاصة بـ {{title}}", j = "اختصارات لوحة المفاتيح", k = "اللغة", z = "Left Arrow", tt = "القائمة الرئيسية", At = "{{count}} دقيقة", ot = "{{count}} من الدقائق", nt = "حجب", Et = "تم الحجب", ct = "لغة التسمية التوضيحية التالية", Tt = "نتيجة البحث التالية", _t = "إيقاف تشغيل", st = "بالأعلى", St = "افتح التعليق التوضيحي في {{time}}", Nt = "افتح الاختبار الموجز المكتمل في {{time}}", Rt = "افتح الاختبار الموجز في {{time}}", Ot = "إيقاف مؤقت", It = "تشغيل", Ct = "سرعة التشغيل", Pt = "سرعة التشغيل: {{speed}}x", Ut = "لغة التسمية التوضيحية السابقة", Lt = "نتيجة البحث السابقة", Dt = "الجودة", et = "قائمة الجودة", Mt = "الرد", ut = "إعادة تعيين سرعة التشغيل", Gt = "سهم اليمين", Yt = "البحث في النسخة النصية", rt = "{{count}} ثانية", Ht = "{{count}} من الثواني", Vt = "بحث للوراء: {{seconds}} من الثواني", Bt = "بحث للأمام: {{seconds}} من الثواني", at = "الإعدادات", it = "اختصار", Kt = "تفاصيل وأدوات الوسائط", mt = "مسافة", Ft = "قائمة سرعة التشغيل", dt = "بدء التمرير التلقائي", lt = "تبديل التسميات التوضيحية", Wt = "تبديل كتم الصوت", $t = "تبديل تشغيل/إيقاف مؤقت", gt = "هو {{count}} سطر نسخة نصية", ht = "هي {{count}} أسطر نسخة نصية", Qt = "جارٍ تحميل النسخة النصية...", Jt = "لم نتمكن من تحميل النسخة النصية.", pt = "خيارات النسخة النصية", xt = "إعادة المحاولة", Zt = "النسخة النصية غير متاحة", ft = "سهم لأعلى", Xt = "إعدادات الفيديو", qt = "مستوى الصوت", vt = "مستوى الصوت: {{volume}}%", wt = {
  A11Y_DURATION: t,
  A11Y_SEARCH_HITS: A,
  A11Y_SEARCH_NO_RESULTS: o,
  A11Y_SEARCH_RESULTS_FOUND: n,
  A11Y_SEARCH_RESULTS_FOUND_other: E,
  A11Y_TIMESTAMP_JUMP_HOURS: c,
  A11Y_TIMESTAMP_JUMP_MINUTES: T,
  A11Y_TIMESTAMP_JUMP_SECONDS: _,
  A11Y_TRANSCRIPT_ERROR: s,
  A11Y_TRANSCRIPT_LINE: S,
  A11Y_TRANSCRIPT_LINES: N,
  A11Y_TRANSCRIPT_SAVING: R,
  A11Y_TRANSCRIPT_SUCCESS: O,
  A11Y_UPDATE_CAPTIONS_AVAILABLE: I,
  ACTION: C,
  ADD_ANNOTATION_AT: P,
  ADD_QUESTION_AT: U,
  ANNOTATIONS: L,
  AUTO: D,
  AUTO_QUALITY: e,
  BACK: M,
  CAPTIONS: u,
  CAPTIONS_LANGUAGE: G,
  CAPTIONS_MANAGE: Y,
  CAPTION_DELETE: r,
  CAPTION_FONT_SIZE: H,
  CAPTION_LANGUAGE: V,
  CAPTION_LANGUAGE_AUTOMATIC: B,
  CLEAR_SEARCH: a,
  CLOSE: i,
  COMMENTS: K,
  CONTINUE: m,
  DECREASE_PLAYBACK_SPEED: F,
  DECREASE_VOLUME: d,
  DOWN_ARROW: l,
  EDIT_CLOSE: W,
  EDIT_CONFIRM: $,
  EDIT_ERROR: g,
  EDIT_SAVING: h,
  EDIT_SUCCESS: Q,
  EDIT_TRANSCRIPT: J,
  EDIT_VALIDATION_ERROR: p,
  FULLSCREEN: x,
  HOURS: Z,
  HOURS_other: f,
  INCREASE_PLAYBACK_SPEED: X,
  INCREASE_VOLUME: q,
  INVERT_COLORS: v,
  JUMP_TO_PERCENTAGE: w,
  JUMP_TO_START: y,
  KEBAB_MENU: b,
  KEYBOARD_SHORTCUTS: j,
  LANGUAGE: k,
  LEFT_ARROW: z,
  MAIN_MENU: tt,
  MINUTES: At,
  MINUTES_other: ot,
  MUTE: nt,
  MUTED: Et,
  NEXT_CAPTION_LANGUAGE: ct,
  NEXT_HIT: Tt,
  OFF: _t,
  ON_TOP: st,
  OPEN_ANNOTATION_AT: St,
  OPEN_COMPLETED_QUIZ_AT: Nt,
  OPEN_QUIZ_AT: Rt,
  PAUSE: Ot,
  PLAY: It,
  PLAYBACK_SPEED: Ct,
  PLAYBACK_SPEED_MESSAGE: Pt,
  PREVIOUS_CAPTION_LANGUAGE: Ut,
  PREVIOUS_HIT: Lt,
  QUALITY: Dt,
  QUALITY_MENU: et,
  REPLAY: Mt,
  RESET_PLAYBACK_SPEED: ut,
  RIGHT_ARROW: Gt,
  SEARCH_TRANSCRIPT_PLACEHOLDER: Yt,
  SECONDS: rt,
  SECONDS_other: Ht,
  SEEK_BACKWARD: Vt,
  SEEK_FORWARD: Bt,
  SETTINGS: at,
  SHORTCUT: it,
  SIDEBAR: Kt,
  SPACE: mt,
  SPEED_MENU: Ft,
  START_AUTOSCROLL: dt,
  TOGGLE_CAPTIONS: lt,
  TOGGLE_MUTED: Wt,
  TOGGLE_PLAY_PAUSE: $t,
  TRANSCRIPT_LINES: gt,
  TRANSCRIPT_LINES_other: ht,
  TRANSCRIPT_LOADING: Qt,
  TRANSCRIPT_LOAD_ERROR: Jt,
  TRANSCRIPT_OPTIONS: pt,
  TRANSCRIPT_RETRY: xt,
  TRANSCRIPT_UNAVAILABLE: Zt,
  UP_ARROW: ft,
  VIDEO_SETTINGS: Xt,
  VOLUME: qt,
  VOLUME_VALUE: vt
};
export {
  t as A11Y_DURATION,
  A as A11Y_SEARCH_HITS,
  o as A11Y_SEARCH_NO_RESULTS,
  n as A11Y_SEARCH_RESULTS_FOUND,
  E as A11Y_SEARCH_RESULTS_FOUND_other,
  c as A11Y_TIMESTAMP_JUMP_HOURS,
  T as A11Y_TIMESTAMP_JUMP_MINUTES,
  _ as A11Y_TIMESTAMP_JUMP_SECONDS,
  s as A11Y_TRANSCRIPT_ERROR,
  S as A11Y_TRANSCRIPT_LINE,
  N as A11Y_TRANSCRIPT_LINES,
  R as A11Y_TRANSCRIPT_SAVING,
  O as A11Y_TRANSCRIPT_SUCCESS,
  I as A11Y_UPDATE_CAPTIONS_AVAILABLE,
  C as ACTION,
  P as ADD_ANNOTATION_AT,
  U as ADD_QUESTION_AT,
  L as ANNOTATIONS,
  D as AUTO,
  e as AUTO_QUALITY,
  M as BACK,
  u as CAPTIONS,
  G as CAPTIONS_LANGUAGE,
  Y as CAPTIONS_MANAGE,
  r as CAPTION_DELETE,
  H as CAPTION_FONT_SIZE,
  V as CAPTION_LANGUAGE,
  B as CAPTION_LANGUAGE_AUTOMATIC,
  a as CLEAR_SEARCH,
  i as CLOSE,
  K as COMMENTS,
  m as CONTINUE,
  F as DECREASE_PLAYBACK_SPEED,
  d as DECREASE_VOLUME,
  l as DOWN_ARROW,
  W as EDIT_CLOSE,
  $ as EDIT_CONFIRM,
  g as EDIT_ERROR,
  h as EDIT_SAVING,
  Q as EDIT_SUCCESS,
  J as EDIT_TRANSCRIPT,
  p as EDIT_VALIDATION_ERROR,
  x as FULLSCREEN,
  Z as HOURS,
  f as HOURS_other,
  X as INCREASE_PLAYBACK_SPEED,
  q as INCREASE_VOLUME,
  v as INVERT_COLORS,
  w as JUMP_TO_PERCENTAGE,
  y as JUMP_TO_START,
  b as KEBAB_MENU,
  j as KEYBOARD_SHORTCUTS,
  k as LANGUAGE,
  z as LEFT_ARROW,
  tt as MAIN_MENU,
  At as MINUTES,
  ot as MINUTES_other,
  nt as MUTE,
  Et as MUTED,
  ct as NEXT_CAPTION_LANGUAGE,
  Tt as NEXT_HIT,
  _t as OFF,
  st as ON_TOP,
  St as OPEN_ANNOTATION_AT,
  Nt as OPEN_COMPLETED_QUIZ_AT,
  Rt as OPEN_QUIZ_AT,
  Ot as PAUSE,
  It as PLAY,
  Ct as PLAYBACK_SPEED,
  Pt as PLAYBACK_SPEED_MESSAGE,
  Ut as PREVIOUS_CAPTION_LANGUAGE,
  Lt as PREVIOUS_HIT,
  Dt as QUALITY,
  et as QUALITY_MENU,
  Mt as REPLAY,
  ut as RESET_PLAYBACK_SPEED,
  Gt as RIGHT_ARROW,
  Yt as SEARCH_TRANSCRIPT_PLACEHOLDER,
  rt as SECONDS,
  Ht as SECONDS_other,
  Vt as SEEK_BACKWARD,
  Bt as SEEK_FORWARD,
  at as SETTINGS,
  it as SHORTCUT,
  Kt as SIDEBAR,
  mt as SPACE,
  Ft as SPEED_MENU,
  dt as START_AUTOSCROLL,
  lt as TOGGLE_CAPTIONS,
  Wt as TOGGLE_MUTED,
  $t as TOGGLE_PLAY_PAUSE,
  gt as TRANSCRIPT_LINES,
  ht as TRANSCRIPT_LINES_other,
  Qt as TRANSCRIPT_LOADING,
  Jt as TRANSCRIPT_LOAD_ERROR,
  pt as TRANSCRIPT_OPTIONS,
  xt as TRANSCRIPT_RETRY,
  Zt as TRANSCRIPT_UNAVAILABLE,
  ft as UP_ARROW,
  Xt as VIDEO_SETTINGS,
  qt as VOLUME,
  vt as VOLUME_VALUE,
  wt as default
};
